import { render } from "./UnauthorizedPanel.vue?vue&type=template&id=eb5cf3fc&scoped=true&lang=html"
import script from "./UnauthorizedPanel.vue?vue&type=script&lang=js"
export * from "./UnauthorizedPanel.vue?vue&type=script&lang=js"

import "./UnauthorizedPanel.vue?vue&type=style&index=0&id=eb5cf3fc&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb5cf3fc"]])

export default __exports__